export const locale = {
    lang: 'en',
    data: {
        PROFILE_TOP: {
            TITLES: {
                EDIT: 'Edit',
            }
        }
    }
};